import React, { useState } from "react";

export default function TagInput({ loading, label, value, setValue }) {

    const [inputValue, setInputValue] = useState("");

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && inputValue.trim() !== "") {
            e.preventDefault();

            if (value.length >= 3) return;
            setValue([...value, inputValue.trim()]);
            setInputValue("");
        }
    };

    const removeTag = (index) => {
        setValue(value.filter((_, i) => i !== index));
    };

    return (
        <div className="md:flex md:items-start mb-6">
            <div className="md:w-1/3">
                <label className="block text-gray-500 font-bold mb-2">
                    {label} {loading ? "Loading..." : ""}
                </label>
            </div>

            <div className="md:w-2/3">


                <div className="flex flex-wrap items-center gap-2 border border-gray-300 rounded-md min-h-[36px] px-[5px] py-[2px]">
                    {value?.map((tag, index) => (
                        <div
                            key={index}
                            className="bg-gray-100 border border-gray-500 text-gray-700 px-2 py-[2px] rounded flex items-center"
                        >
                            {tag}
                            <button
                                type="button"
                                className="ml-2 text-canvas-primary font-bold hover:text-red-600"
                                onClick={() => removeTag(index)}
                            >
                                ×
                            </button>
                        </div>
                    ))}

                    {value?.length < 3 && (
                        <input
                            type="text"
                            value={inputValue}
                            placeholder="Type and press Enter..."
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={handleKeyDown}
                            className="flex-1 bg-transparent appearance-none border-1 border-gray-200 rounded py-1 px-4
                                       text-gray-700 leading-tight focus:outline-none focus:bg-white
                                       focus:border-gray-500 min-w-[120px]"
                        />
                    )}
                </div>
                {value.length >= 3 && (
                    <p className="text-gray-600 text-sm mb-1 font-semibold">
                        Max. 3 address search is allowed
                    </p>
                )}
            </div>

        </div>
    );
}
